export default __webpack_public_path__ + "static/media/placeholder_dummy2016-weinhandel01-de.17eee5e1.png";